import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../../../services/WiMuleSQL";

export const useGetOrdersByDateAndAsset = (fromDateTime, toDateTime, asset) => {
  // Helper function to format dates
  const formatFromDate = (date) => {
    date.setHours(0, 0, 1); // Start of the day
    return date.toISOString().split(".")[0];
  };

  const formatToDate = (date) => {
    date.setHours(23, 59, 59); // End of the day
    return date.toISOString().split(".")[0];
  };

  const fetchData = async () => {
    // Start building the query string
    const queryParams = new URLSearchParams();

    if (fromDateTime) {
      queryParams.append("fromDate", formatFromDate(new Date(fromDateTime)));
    }
    if (toDateTime) {
      queryParams.append("toDate", formatToDate(new Date(toDateTime)));
    }
    if (asset) {
      queryParams.append("asset", asset);
    }

    const queryString = `${WiMuleSQL}/api/WiTool/GetServerOrders?${queryParams.toString()}`;

    const response = await fetch(queryString, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    return response.json();
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getOrdersByDateAndAsset", fromDateTime, toDateTime, asset],
    queryFn: fetchData,
    enabled: !!asset, // Enable query only if the asset is provided
  });

  return { data, isLoading, isError, error };
};
